import GameModel from "../core/src/model/GameModel";
import App from "../core/src/App";
import GameEvents from "../core/src/const/GameEvents";
import SoundController from "../core/src/utils/SoundController";
import UIController from "../core/src/ui/UIController";
import { UIStates } from "../core/src/ui/UIStates";
import StateMachine from "../core/src/states/StateMachine";
import CommManager from "../core/src/controllers/CommManager";
import RequestRegister from "../core/src/server/requests/RequestRegister";
import BetModel from "../core/src/model/BetModel";
import * as FEIM from "@rlx/feim";
import ViewManager from '../core/src/utils/ViewManager';
import { Commands } from '../core/src/commands/CommandEnum';
import CommandManager from '../core/src/commands/CommandManager';
import IFeimConfigureDate from '../server/IFeimConfigureData';
import { ConfigurationTypes } from '../core/src/const/ConfigurationTypes';
import ConsoleUtil from '../core/src/utils/ConsoleUtil';


declare var RgPostMessageAPI;

export class RelaxPOSTMessageController {
  private relaxAPI: any = RgPostMessageAPI;
  private feimAPI: any = FEIM;
  private onLogs: boolean = false;

  private useFEIM = true;

  public initializeAPI() {
    if (this.useFEIM) {
      ///////////////////////////////////
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Initialize");

      }
      this.setupEventListeners();
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Initialize");

      }
      this.relaxAPI.init(true);
      this.setupEventListeners();
    }
  }

  public configure(data: IFeimConfigureDate): void
  public configure(data: any): void {
    if (this.useFEIM) {
      ///////////////////////////////////
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Configure");

      }
      let configData = this.getFeimConfigData(data);
      this.feimAPI.configure(configData)
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method");

      }
    }
  }

  public reportGameReady() {
    if (this.useFEIM) {
      /////////////////////////////
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Don't have this method");

      }
    } else {
      this.relaxAPI.reportGameReady();
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Game Ready");

      }
    }
  }

  private setupEventListeners() {
    if (this.useFEIM) {
      ///////////////////////////////
      this.feimAPI.on.freeze((event) => {
        if (this.onLogs) {
          ConsoleUtil.red("[RelaxPostMessage] onPause()", event);

        }
        this.setPauseOn(event);
        ViewManager.getLayer("SplashOverlay").setScene("open");
      });

      this.feimAPI.on.unfreeze((event) => {
        if (this.onLogs) {
          ConsoleUtil.red("[RelaxPostMessage] onResume()", event);

        }
        this.setPauseOff();
        ViewManager.getLayer("SplashOverlay").clear();
      });

      this.feimAPI.on.updateSettings((settings: any) => {
        console.warn('Update sound settings using event listener');
        this.changeSound(settings.sounds)
        this.reportSound();
      })

      this.feimAPI.on.refreshBalance(() => {
        GameModel.shouldUpdateBalance = true;
        if (StateMachine.currentState.name == "idle") {
          UIController.setState(UIStates.SPIN);
          CommManager.send(RequestRegister.get("getBalance"), (data) => {
            BetModel.balance = data.b;
            UIController.setState(UIStates.IDLE);
            this.balanceUpdate(data.b);
          }, this);
        }
      })

      App.dispatcher.on(GameEvents.SOUNDS_UNMUTED, () => {
        this.reportSound();
      }, this);

      App.dispatcher.on(GameEvents.SOUNDS_MUTED, () => {
        this.reportSound();
      })
    } else {
      window.addEventListener("rg_pause", (event) => {
        if (this.onLogs) {
          ConsoleUtil.red("[RelaxPostMessage] onPause()", event);

        }
        this.setPauseOn(event);
      });

      window.addEventListener("rg_resume", (event) => {
        if (this.onLogs) {
          ConsoleUtil.red("[RelaxPostMessage] onResume()", event);

        }
        this.setPauseOff();
      });

      window.addEventListener("rg_setSounds", (event: any) => {
        this.changeSound(event.data.enableSounds)
        this.reportSound();
      })

      window.addEventListener("rg_updateBalance", (event: any) => {
        GameModel.shouldUpdateBalance = true;
        if (StateMachine.currentState.name == "idle") {
          UIController.setState(UIStates.SPIN);
          CommManager.send(RequestRegister.get("getBalance"), (data) => {
            BetModel.balance = data.b;
            UIController.setState(UIStates.IDLE);
          }, this);
        }
      })

      App.dispatcher.on(GameEvents.SOUNDS_UNMUTED, () => {
        this.reportSound();
      }, this);

      App.dispatcher.on(GameEvents.SOUNDS_MUTED, () => {
        this.reportSound();
      })
    }
  }

  private setPauseOn(event: any) {
    if (this.useFEIM) {
      /////////////////////////////////////////////
      if (event?.data && event?.data?.autoPlayOnly) {
        GameModel.shouldStopAutoplay = true;
      } else {
        GameModel.shouldPauseGame = true;
        GameModel.shouldStopAutoplay = true;
        if (StateMachine.currentState.name == "idle") {
          UIController.setState(UIStates.SPIN);
        }
      }
    } else {
      if (event.data && event.data.autoPlayOnly) {
        GameModel.shouldStopAutoplay = true;
      } else {
        GameModel.shouldPauseGame = true;
        GameModel.shouldStopAutoplay = true;
        if (StateMachine.currentState.name == "idle") {
          this.reportPaused();
          UIController.setState(UIStates.SPIN);
        }
      }
    }
  }

  private setPauseOff() {
    if (this.useFEIM) {
      /////////////////////////////////////////////
      GameModel.shouldStopAutoplay = false;
      GameModel.shouldPauseGame = false;
      App.dispatcher.emit(GameEvents.GAME_UNPAUSED);
      UIController.setState(UIStates.IDLE);
    } else {
      GameModel.shouldStopAutoplay = false;
      GameModel.shouldPauseGame = false;
      App.dispatcher.emit(GameEvents.GAME_UNPAUSED);
      UIController.setState(UIStates.IDLE);
    }
  }

  public gameRoundStarted(balance) {
    if (this.useFEIM) {
      this.feimAPI.send.roundStarted(balance);
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Round Start")

      }
      ////////////////////////////////////////////
    } else {
      this.relaxAPI.gameRoundStarted(balance);
    }
  }

  public sendUserAction(actionUrl: string) {
    if (this.useFEIM) {
      ////////////////////////////////////////////////
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] User Action")

      }
      this.feimAPI.send.navigate(actionUrl);
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Send user action: " + actionUrl);

      }
      this.relaxAPI.userAction(actionUrl);
    }
  }

  public gameRoundEnded(balance) {
    if (this.useFEIM) {
      //////////////////////////////////////////////////
      this.feimAPI.send.roundFinished(balance);
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Round End")

      }
    } else {
      this.relaxAPI.gameRoundEnded(balance);
    }
  }

  private changeSound(enableSounds: boolean) {
    if (this.useFEIM) {
      /////////////////////////////////////////////////
      SoundController.toggleMasterSound({ data: { value: enableSounds } });
      CommandManager.execute(Commands.SAVE_SETTINGS);
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Sound Change")

      }
    } else {
      SoundController.toggleMasterSound({ data: { value: enableSounds } });
    }
  }

  public reportPaused() {
    if (this.useFEIM) {
      ///////////////////////////////////////////////
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Don't have this method")

      }
    } else {
      this.relaxAPI.reportPaused();
    }
  }

  public reportSound() {
    if (this.useFEIM) {
      ///////////////////////////////////////////////////////
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Report Sound")

      }
      this.feimAPI.send.updateSettings({ sounds: SoundController.isSoundEnabled });
    } else {
      this.relaxAPI.reportSettings({ enableSounds: !!SoundController.masterVolume });
    }
  }

  ////////////////////////// NEW METHODS FROM FEIM API /////////////////////
  public featureStarted(): void {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Feature Start");

      }
      this.feimAPI.send.featureStarted();
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public featureFinished(): void {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Feature Finish");

      }
      this.feimAPI.send.featureFinished();
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public gameLoadCompleted(): void {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Game Load Complete");

      }
      this.feimAPI.send.gameLoadCompleted();
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public gameLoadProgress(progress: number): void {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Game Load Progress");

      }
      this.feimAPI.send.gameLoadProgress(progress);
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public gameLoadStarted(): void {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Game Load Started");

      }
      this.feimAPI.send.gameLoadStarted();
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public autoPlayStarted() {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Autoplay Start");

      }
      this.feimAPI.send.autoPlayStarted();
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public autoPlayFinished() {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Autoplay Finish");

      }
      this.feimAPI.send.autoPlayFinished();
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public winUpdate(win: number) {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Win Update");

      }
      this.feimAPI.send.winUpdate(win);
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }
  public betUpdate(bet: number) {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Bet Update");
      }
      this.feimAPI.send.betUpdate(bet);
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public balanceUpdate(balance: number) {
    if (this.useFEIM) {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage FEIM API] Balance Update");

      }
      this.feimAPI.send.balanceUpdate(balance);
    } else {
      if (this.onLogs) {
        ConsoleUtil.red("[RelaxPostMessage] Don't have this method")

      }
    }
  }

  public getFeimConfigData(data: IFeimConfigureDate): IFeimConfigureDate {
    // return ({
    //   clientConfig: {
    //     gameServerApi: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).clientconfigurl,
    //     // The casino login response, or an object adhering to its format
    //     // (Relax game server users only):
    //     loginResponse: data,
    //   },
    //   p2pConfig: {
    //     currency: data.stats.currency
    //   },
    //   currencyCode: data.stats.currency,

    //   /* If set to true, FEIM will handle the responsibilities of RgPostMessageAPI library. If true, RgPostMessageAPI library or any equivalent/duplicate integration must be removed from the game. */
    //   handleRgPostMessageAPI: false,

    //   /* Some jurisdictions require that the game needs to wait for a user confirmation when
    //   a bonus game is reached. Set this to false if the game handles it internally. */
    //   handleFeaturePause: true,

    //   showErrorMessageCallback: message => {
    //     alert("There's an error!!")

    //     console.error(message);
    //   }
    // });
    let result = {};

    data?.clientconfigResponse ? result["clientConfig"] = data.clientconfigResponse : null;
    data?.loginResponse ? result["loginResponse"] = data.loginResponse : null;
    data?.p2pConfig ? result["p2pConfig"] = data.p2pConfig : null;
    data?.handleRgPostMessageAPI ? result["handleRgPostMessageAPI"] = data.handleRgPostMessageAPI : result["handleRgPostMessageAPI"] = true;
    data?.handleFeaturePause ? result["handleFeaturePause"] = data.handleFeaturePause : result["handleFeaturePause"] = false;
    data?.showErrorMessageCallback ? result["showErrorMessageCallback"] = data.showErrorMessageCallback : null;

    return result
  }
}

export default new RelaxPOSTMessageController();
